import React from 'react'
import ContactUs from '../containers/ContactUs/ContactUs'
import Seo from '../common/Components/Seo/Seo'
import ContactSchema from '../common/Components/StructuredData/ContactSchema'

const ContactPage = () => {
  return (
    <div>
          <Seo
           seo={{
             title: "Contact Us | Airport Parking Deals Customer Support",
             description: "Need help with your airport parking booking? Contact Airport Parking Deals for assistance. Email us at info@dummy.co.uk or call 00000000000. We're here to help with all major airports.",
             keywords: "contact airport parking deals, customer support parking, contact airport parking, parking enquiries, booking assistance, airport parking help"
           }}/>
          <ContactSchema />
        <ContactUs/>
    </div>
  )
}

export default ContactPage
